// eslint-disable-next-line no-restricted-imports
import {ParamComponent} from 'panel';
import keyBy from 'lodash/keyBy';

import {IronContextRegistry} from 'common/report/context-registry';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2reactSnabbdomWrapper} from 'common/util/react-snabbdom-wrapper';
import {ChartType} from 'common/types/reports/bookmark';
import {getBookmarkParamsWithOverrides} from 'common/report/dashboards/bookmark-overrides';
import {RetentionCurveChartProps} from 'common/report/insights/charts/retention-curve-chart';

import {template} from './template';

export class Card extends ParamComponent<any, EmptyObj, IronContextRegistry> {
  get config() {
    return {
      template,
      defaultParams: {
        dataGroups: null,
        bookmark: null,
        chartParams: null,
        utcOffset: 0,
        projectId: ``,
      },
      params: {
        dataGroups: Object,
        cardTitle: String,
        chartOptions: Object,
        projectTimezone: String,
        reportLoading: Boolean,
        utcOffset: Number,
        bookmark: Object,
        chartParams: Object,
        projectId: String,
        chartEventsInfo: Object,
      },
      contexts: [
        `urlManager` as const,
        `currentProject` as const,
        `localStorageManager` as const,
        `currentUser` as const,
        `metrics` as const,
      ],
    };
  }

  connectedCallback() {
    super.connectedCallback();
  }

  ChartType = ChartType;

  getDataGroups = () => {
    // return Record<string, DataGroup>
    // this format is used in line and bar charts
    if (!this.params.dataGroups) {
      return null;
    } else {
      return keyBy(this.params.dataGroups, `groupID`);
    }
  };

  getBookmarkParamsWithDashboardOverrides = () => {
    // Common report chart widgets accept raw bookmark params
    const bookmark = this.params.bookmark;
    const chartOptions = this.params.chartOptions;
    const timeFilter = this.params.timeFilter;
    return getBookmarkParamsWithOverrides({
      bookmarkParams: bookmark.params,
      bookmarkType: bookmark.type,
      chartTypeOverride: chartOptions.type,
      timeFilterOverride: timeFilter,
      additionalFilters: this.params.globalFilters,
    });
  };

  getFunnelStepsBookmarkData = () => {
    return {
      queryResults: this.params.chartParams,
      bookmark: this.getBookmarkParamsWithDashboardOverrides(),
    };
  };

  getFlowSankeyChartAttributes = () => ({
    loaded: !this.params.reportLoading,
    'scroll-offset': 0,
    'tooltip-enabled': true,
    'disable-add-steps': true,
    'disable-click-node': true,
  });

  getFlowsChartWidgetProps = () => ({
    paramsAndResults: {
      params: this.getBookmarkParamsWithDashboardOverrides(),
      results: this.params.chartParams,
    },
  });

  // TODO: Merge these all together when we consolidate Retention trends chart props
  getAttributesForRetentionChart = (): Partial<RetentionCurveChartProps> => {
    return {
      projectTimezone: this.params.projectTimezone,
      utcOffset: this.params.utcOffset,
      limitDisplayedSegments: true,
    };
  };

  getParamsForRetentionCurveChart = () => {
    const params = this.getAttributesForRetentionChart();
    const bookmarkParams = this.getBookmarkParamsWithDashboardOverrides();
    return {
      ...params,
      bookmarkData: {
        bookmark: bookmarkParams,
        queryResults: this.params.chartParams,
      },
    };
  };
}

export const CardEl = defineAndMakeJsxFactory<any>(`mp-dash-card-immersive`, Card);
export const CardSnabbdom = panel2reactSnabbdomWrapper<any>({
  jsxFactory: CardEl,
});
